<template v-slot="main">
  <div class="modal-container">
    <div class="modal-header">
      <h2>{{ $t('transfer_modal.title') }}</h2>
    </div>

    <div class="modal-body">
      <p>{{ $t('transfer_modal.select_skill') }}</p>
      <ul>
        <li v-for="(skill, index) in $store.getters['user/getUserSkills']"
            v-bind:key="index">
          <button v-on:click="chooseSkill(skill)" class="btn btn-squared btn-big">
            <h3>{{ skill.label }}</h3>
            <p>{{ $t('transfer_modal.skill_estimated_waiting_time') }}</p>
            <p>{{ skill.waiting | moment(settings.date.shorttimeFormat) }}</p>
          </button>
        </li>
      </ul>
    </div>

    <div class="modal-footer">
      <button v-on:click="closeModal" class="btn">
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import VueMomentJS from 'vue-moment'

import BaseModal from '@/layout/modals/BaseModal.vue'

Vue.use(VueMomentJS, moment)
Vue.moment.locale(window.navigator.language)

export default {
  extends: BaseModal,
  name: 'TransferRoomModal',
  computed: {
    settings () {
      return this.$settings
    }
  },
  methods: {
    chooseSkill (skill) {
      this.$store.dispatch('rooms/sendTransferRoom', skill.uuid)
      this.closeModal()
      this.$store.dispatch('global/showModal', 'transferred')
    }
  }
}

</script>

<style lang="scss">
.modal-body {
  ul {
    list-style: none;
    display: flex;
    flex-direction: rows;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    li {
      margin: 0;
      padding: 0;

      .btn {
        display: flex;
        flex-direction: column;

        p {
          opacity: .6;
        }
      }
    }
  }
}
</style>
